module.exports = __webpack_public_path__ + "img/epicycloid_curve.0522dd7b.png";